import { render, staticRenderFns } from "./FranchiseeDocumentList.vue?vue&type=template&id=0cb7f413&scoped=true&"
import script from "./FranchiseeDocumentList.vue?vue&type=script&lang=js&"
export * from "./FranchiseeDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseeDocumentList.vue?vue&type=style&index=0&id=0cb7f413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7f413",
  null
  
)

export default component.exports